// import { Link, useNavigate } from 'react-router-dom'
// import { assets, subjects } from '../../../data/assests'

// const SubjectPanel = () => {
//     const navigate = useNavigate()

//     return (
//         <section style={
//             {
//                 backgroundImage: `url("${assets.middle_image}")`,
//                 backgroundSize: '100% 100%',
//                 backgroundAttachment: 'fixed'
//             }
//         } className="py-20">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                 <h2 style={
//                     {
//                         textShadow: '0 0 10px orange'
//                     }
//                 } className="text-4xl font-bold text-center mb-12 text-accent">
//                     الاختصاصات المتاحة
//                 </h2>
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//                     {subjects.map((subject) => (
//                         <Link
//                             onClick={() => {
//                                 navigate('/teachers')
//                                 localStorage.setItem('filter', subject.key)
//                                 window.scrollTo(0, 0);
//                             }}
//                             key={subject.key}
//                             className="flex items-center flex-col bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow text-center group cursor-pointer"
//                         >
//                             <div className="text-3xl mb-3 group-hover:scale-110 transition-transform">
//                                 <img src={subject.icon} className='w-[60px]' alt="" />
//                             </div>
//                             <h3 className="font-semibold text-gray-800">{subject.name}</h3>
//                         </Link>
//                     ))}
//                 </div>
//             </div>
//         </section>
//     )
// }

// export default SubjectPanel







import { Link, useNavigate } from "react-router-dom";
import { subjects } from '../../../data/assests';
import React from "react";

const SubjectPanel = () => {
  const navigate = useNavigate();

  const handleClick = (key) => {
    localStorage.setItem('filter', key);
    navigate('/doctors');
    window.scrollTo(0, 0);
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-cyan-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          style={{ textShadow: "0 0 10px rgba(0, 150, 200, 0.3)" }}
          className="text-4xl font-bold text-center mb-12 text-blue-900"
        >
          الاختصاصات الطبية المتاحة
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {subjects.map((subject) => (
            <div
              key={subject.key}
              onClick={() => handleClick(subject.key)}
              className="flex items-center flex-col bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all text-center group cursor-pointer hover:scale-105"
              title={subject.name} // يظهر عند المرور على المربع
            >
              <div className="text-blue-600 mb-3 group-hover:text-cyan-600 transition-colors">
                <subject.icon className="w-16 h-16 mx-auto" />
              </div>
              <h3 className="font-semibold text-gray-800">{subject.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SubjectPanel;







// import { Link } from "react-router-dom";
// import { subjects } from '../../../data/assests';

// const SubjectPanel = () => {
//   return (
//     <section className="py-20 bg-gradient-to-br from-blue-50 to-cyan-100">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <h2
//           style={{ textShadow: "0 0 10px rgba(0, 150, 200, 0.3)" }}
//           className="text-4xl font-bold text-center mb-12 text-blue-900"
//         >
//           الاختصاصات الطبية المتاحة
//         </h2>

//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
//           {subjects.map((subject) => (
//             <Link
//               to="/doctors"
//               onClick={() => {
//                 localStorage.setItem('filter', subject.key);
//                 window.scrollTo(0, 0);
//               }}
//               key={subject.key}
//               className="flex items-center flex-col bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all text-center group cursor-pointer hover:scale-105"
//             >


//               <div className="text-blue-600 mb-3 group-hover:text-cyan-600 transition-colors">
//   <subject.icon className="w-16 h-16 mx-auto" />
// </div>

//           {/* <div className="text-blue-600 mb-3 group-hover:text-cyan-600 transition-colors">

//               <img
//                   src={subject.icon}
//                   className="w-16 h-16 mx-auto"
//                   alt={subject.name}
//                 /> 
//               </div> */}
//               <h3 className="font-semibold text-gray-800">{subject.name}</h3>
//             </Link>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SubjectPanel;


